// extracted by mini-css-extract-plugin
export default {"wrapper":"Success_wrapper__LLgm8","container":"Success_container__25txA"};